import SuperJSON from "superjson";
import Id from "../types/Id";

export default class WebhookId extends Id<"webhook"> {}

SuperJSON.registerClass(WebhookId);
